import { environment } from '../../../environments/environment';

/** Hide the weekly report schedule until this environment turns it on. */
export function isScheduledReportsEnabled(): boolean {
  return environment.scheduledReports?.enabled === true;
}
